module.exports = __webpack_public_path__ + "static/media/contract-step4.94922bc9.png";